export default __webpack_public_path__ + "static/LGBTQ-flag-697ae3061d5202c4db61c0d0b3829b50.svg";